/* eslint-disable */
//
//  StyleKit.js
//  SLComponents
//
//  Created by Sergio Maldonado on 12/5/18.
//  Copyright © 2018 Softwareland. All rights reserved.
//
//  Generated by PaintCode
//  http://www.paintcodeapp.com
//

//// APIs you can use in your code:
//
// Available methods for drawing into <canvas> elements:
//    StyleKit.drawDonut(canvas, primaryColor, textColor, progress, targetFrame*, resizing*)
//
// NOTE: 'canvas' parameter can be either a <canvas> element object, or the id of a <canvas> element in your document.
//
// NOTE: Parameters marked with the '*' symbol are optional
//
// NOTE: Possible arguments for 'resizing' parameter in drawing methods are:
//   'aspectfit': The content is proportionally resized to fit into the target rectangle.
//   'aspectfill': The content is proportionally resized to completely fill the target rectangle.
//   'stretch': The content is stretched to match the entire target rectangle.
//   'center': The content is centered in the target rectangle, but it is NOT resized.
//
// Available Utilities:
//    StyleKit.clearCanvas(canvas)
//    StyleKit.makeColor(r, g, b, a)  // Arguments should be from interval 0..1
//    StyleKit.makeRect(x, y, width, height)

//// Create StyleKit Object
var StyleKit = {};
(function() {
    //// Drawing Methods

    function drawDonut(
        canvas,
        primaryColor,
        textColor,
        progress,
        targetFrame,
        resizing
    ) {
        //// General Declarations
        canvas = initializeCanvas(
            typeof canvas === 'string'
                ? document.getElementById(canvas)
                : canvas
        );
        var context = canvas.getContext('2d');
        var pixelRatio = canvas.paintCodePixelRatio;

        //// Resize to Target Frame
        context.save();
        var resizedFrame = applyResizingBehavior(
            resizing,
            makeRect(0, 0, 68, 68),
            targetFrame
        );
        context.translate(resizedFrame.x, resizedFrame.y);
        context.scale(resizedFrame.w / 68, resizedFrame.h / 68);

        //// Color Declarations
        var trackColor = 'rgba(237, 237, 237, 1)';

        //// Variable Declarations
        var angle = -360 * progress + 90;
        var percentaje = '' + Math.round(progress * 100) + '%';
        var textOpacity = progress > 0.99 ? 0 : 1;
        var checkmarkOpacity = progress > 0.99 ? 1 : 0;

        //// TrackOval Drawing
        arc(context, 4, 4, 60, 60, -90, 270, false);
        context.strokeStyle = trackColor;
        context.lineWidth = 7;
        context.lineCap = 'round';
        context.stroke();

        //// CompleteIcon Drawing
        context.save();
        context.globalAlpha = checkmarkOpacity;
        context.beginPath();
        context.moveTo(64, 34);
        context.bezierCurveTo(64, 50.57, 50.57, 64, 34, 64);
        context.bezierCurveTo(17.43, 64, 4, 50.57, 4, 34);
        context.bezierCurveTo(4, 17.43, 17.43, 4, 34, 4);
        context.bezierCurveTo(50.57, 4, 64, 17.43, 64, 34);
        context.closePath();
        context.moveTo(30.53, 49.88);
        context.lineTo(52.79, 27.63);
        context.bezierCurveTo(53.54, 26.87, 53.54, 25.65, 52.79, 24.89);
        context.lineTo(50.05, 22.15);
        context.bezierCurveTo(49.3, 21.4, 48.07, 21.4, 47.31, 22.15);
        context.lineTo(29.16, 40.3);
        context.lineTo(20.69, 31.83);
        context.bezierCurveTo(19.93, 31.07, 18.71, 31.07, 17.95, 31.83);
        context.lineTo(15.21, 34.57);
        context.bezierCurveTo(14.46, 35.32, 14.46, 36.55, 15.21, 37.3);
        context.lineTo(27.79, 49.88);
        context.bezierCurveTo(28.55, 50.64, 29.77, 50.64, 30.53, 49.88);
        context.closePath();
        context.fillStyle = primaryColor;
        context.fill();
        context.restore();

        //// ProgressOval Drawing
        arc(context, 4, 4, 60, 60, -90, -angle, false);
        context.strokeStyle = primaryColor;
        context.lineWidth = 7;
        context.lineCap = 'round';
        context.stroke();

        //// ProgressText Drawing
        context.save();
        context.globalAlpha = textOpacity;
        var progressTextRect = makeRect(4, 4, 60, 60);
        context.fillStyle = textColor;
        context.font =
            '500 17px -apple-system, "Helvetica Neue", Helvetica, sans-serif';
        context.textAlign = 'center';
        var progressTextTotalHeight = 17 * 1.3;
        context.fillText(
            percentaje,
            progressTextRect.x + progressTextRect.w / 2,
            progressTextRect.y +
                16 +
                progressTextRect.h / 2 -
                progressTextTotalHeight / 2
        );
        context.restore();

        context.restore();
    }

    //// Infrastructure

    function clearCanvas(canvas) {
        canvas = initializeCanvas(
            typeof canvas === 'string'
                ? document.getElementById(canvas)
                : canvas
        );
        canvas.getContext('2d').clearRect(0, 0, canvas.width, canvas.height);
    }

    // Possible arguments for 'resizing' parameter are:
    //   'aspectfit': The content is proportionally resized to fit into the target rectangle.
    //   'aspectfill': The content is proportionally resized to completely fill the target rectangle.
    //   'stretch': The content is stretched to match the entire target rectangle.
    //   'center': The content is centered in the target rectangle, but it is NOT resized.
    function applyResizingBehavior(resizing, rect, targetRect) {
        if (
            targetRect === undefined ||
            equalRects(rect, targetRect) ||
            equalRects(targetRect, makeRect(0, 0, 0, 0))
        ) {
            return rect;
        }

        var scales = makeSize(0, 0);
        scales.w = Math.abs(targetRect.w / rect.w);
        scales.h = Math.abs(targetRect.h / rect.h);

        switch (resizing) {
            case 'aspectfit': {
                scales.w = Math.min(scales.w, scales.h);
                scales.h = scales.w;
                break;
            }
            case 'aspectfill': {
                scales.w = Math.max(scales.w, scales.h);
                scales.h = scales.w;
                break;
            }
            case 'stretch':
            case undefined:
                break;
            case 'center': {
                scales.w = 1;
                scales.h = 1;
                break;
            }
            default:
                throw 'Unknown resizing behavior "' +
                    resizing +
                    '". Use "aspectfit", "aspectfill", "stretch" or "center" as resizing behavior.';
        }

        var result = makeRect(
            Math.min(rect.x, rect.x + rect.w),
            Math.min(rect.y, rect.y + rect.h),
            Math.abs(rect.w),
            Math.abs(rect.h)
        );
        result.w *= scales.w;
        result.h *= scales.h;
        result.x = targetRect.x + (targetRect.w - result.w) / 2;
        result.y = targetRect.y + (targetRect.h - result.h) / 2;
        return result;
    }

    function arc(context, x, y, w, h, startAngle, endAngle, isClosed) {
        context.save();
        context.beginPath();
        context.translate(x, y);
        context.scale(w / 2, h / 2);
        context.arc(
            1,
            1,
            1,
            (Math.PI / 180) * startAngle,
            (Math.PI / 180) * endAngle,
            false
        );
        if (isClosed) {
            context.lineTo(1, 1);
            context.closePath();
        }
        context.restore();
    }

    function makeRect(x, y, w, h) {
        return { x: x, y: y, w: w, h: h };
    }

    function equalRects(r1, r2) {
        return r1.x === r2.x && r1.y === r2.y && r1.w == r2.w && r1.h === r2.h;
    }

    function makeSize(w, h) {
        return { w: w, h: h };
    }

    function initializeCanvas(canvas) {
        if ('paintCodePixelRatio' in canvas) return canvas;
        // This function should only be called once on each canvas.
        var context = canvas.getContext('2d');

        var devicePixelRatio = window.devicePixelRatio || 1;
        var backingStorePixelRatio =
            context.webkitBackingStorePixelRatio ||
            context.mozBackingStorePixelRatio ||
            context.msBackingStorePixelRatio ||
            context.oBackingStorePixelRatio ||
            context.backingStorePixelRatio ||
            1;

        var pixelRatio = devicePixelRatio / backingStorePixelRatio;

        canvas.style.width = canvas.width + 'px';
        canvas.style.height = canvas.height + 'px';
        canvas.width *= pixelRatio;
        canvas.height *= pixelRatio;
        canvas.paintCodePixelRatio = pixelRatio;

        context.scale(pixelRatio, pixelRatio);
        return canvas;
    }

    function makeColor(r, g, b, a) {
        return (
            'rgba(' +
            Math.round(255 * r) +
            ', ' +
            Math.round(255 * g) +
            ', ' +
            Math.round(255 * b) +
            ', ' +
            a +
            ')'
        );
    }

    //// Public Interface

    // Drawing Methods
    StyleKit.drawDonut = drawDonut;

    // Utilities
    StyleKit.clearCanvas = clearCanvas;
    StyleKit.makeColor = makeColor;
    StyleKit.makeRect = makeRect;
})();

export default StyleKit;



// WEBPACK FOOTER //
// ./src/lib/StyleKit.js